module.exports = __webpack_public_path__ + "static/media/logo.097b328c.svg";